import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ProductCategory } from '../../../models/product';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
@Component({
  selector: 'app-main-toolbar-dropdown',
  imports: [NgOptimizedImage, FileurlPipe, MatIconModule, RouterModule],
  templateUrl: './main-toolbar-dropdown.html',
  styleUrl: './main-toolbar-dropdown.scss',
})
export class MainToolbarDropdown {
  @Input({ required: true }) category?: ProductCategory;
}
